"use strict";

var _regeneratorRuntime = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query FileUploadInfo {\n    fileUploadInfo {\n      policy\n      signature\n      apiKey\n      path\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_apollo_1 = require("react-apollo");

var filestack = __importStar(require("filestack-js"));

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var FILE_UPLOAD_INFO_QUERY = graphql_tag_1.default(_templateObject());
var FileInput = react_apollo_1.withApollo((_a =
/*#__PURE__*/
// @ts-ignore
function (_react_1$default$Comp) {
  _inherits(FileInput, _react_1$default$Comp);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileInput).call(this, props));

    _this.onUploadDone = function (_ref) {
      var filesUploaded = _ref.filesUploaded;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _this$filestack$sessi, _this$filestack$sessi2, policy, _this$filestack$sessi3, signature, value, originalFile, _this$props, maxFiles, onUploadDone, onChange;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.filestack) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this$filestack$sessi = this.filestack.session, _this$filestack$sessi2 = _this$filestack$sessi.policy, policy = _this$filestack$sessi2 === void 0 ? '""' : _this$filestack$sessi2, _this$filestack$sessi3 = _this$filestack$sessi.signature, signature = _this$filestack$sessi3 === void 0 ? '""' : _this$filestack$sessi3;
                value = filesUploaded.map(function (_ref2) {
                  var handle = _ref2.handle,
                      filename = _ref2.filename,
                      url = _ref2.url,
                      mimetype = _ref2.mimetype;
                  var urlOrigin = url ? new URL(url).origin : '';
                  return {
                    downloadUrl: "".concat(urlOrigin, "/security=p:").concat(policy, ",s:").concat(signature, "/").concat(handle),
                    fileId: handle,
                    filename: filename,
                    mimetype: mimetype,
                    public: !!_this2.props.public
                  };
                });
                originalFile = filesUploaded.map(function (item) {
                  return item.originalFile;
                });
                _this$props = this.props, maxFiles = _this$props.maxFiles, onUploadDone = _this$props.onUploadDone, onChange = _this$props.onChange;

                if (maxFiles === 1) {
                  value = value[0];
                  originalFile = originalFile[0];
                }

                if (!(typeof onUploadDone === 'function')) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return onUploadDone(value, originalFile);

              case 10:
                value = _context.sent;

              case 11:
                this.setState({
                  value: value,
                  originalFile: originalFile
                });

                if (typeof onChange === 'function') {
                  onChange(value, originalFile);
                }

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    _this.collectPickerOptions = function () {
      var maxFiles = _this.props.maxFiles;
      var path = _this.state.path;
      return {
        exposeOriginalFile: true,
        maxFiles: maxFiles,
        onUploadDone: _this.onUploadDone,
        storeTo: {
          path: path
        }
      };
    };

    _this.pick = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var pickerOptions, picker;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.filestackPromise;

              case 2:
                if (this.filestack) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                if ('maxFiles' in options) {
                  console.warn('Specify "maxFiles" as a prop for FileInput component'); // tslint:disable-line
                }

                if ('onUploadDone' in options) {
                  console.warn('Specify "onUploadDone" as a prop for FileInput component'); // tslint:disable-line
                }

                pickerOptions = this.collectPickerOptions();
                picker = this.filestack.picker(Object.assign(Object.assign({}, options), pickerOptions));
                _context2.next = 10;
                return picker.open();

              case 10:
                return _context2.abrupt("return", picker);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    _this.state = {
      error: null,
      originalFile: null,
      path: null,
      value: props.value || null
    };
    return _this;
  }

  _createClass(FileInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.filestackPromise = this.initFilestack();
    }
  }, {
    key: "initFilestack",
    value: function initFilestack() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this$props2, client, sessionCache, response, _response$data$fileUp, apiKey, policy, signature, path;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props2 = this.props, client = _this$props2.client, sessionCache = _this$props2.sessionCache;
                response = null;
                _context3.prev = 2;
                _context3.next = 5;
                return client.query({
                  query: FILE_UPLOAD_INFO_QUERY,
                  fetchPolicy: this.props.fetchPolicy
                });

              case 5:
                response = _context3.sent;
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                this.setState({
                  error: _context3.t0
                });
                return _context3.abrupt("return");

              case 12:
                _response$data$fileUp = response.data.fileUploadInfo, apiKey = _response$data$fileUp.apiKey, policy = _response$data$fileUp.policy, signature = _response$data$fileUp.signature, path = _response$data$fileUp.path;
                this.setState({
                  path: path
                });
                this.filestack = filestack.init(apiKey, {
                  security: {
                    policy: policy,
                    signature: signature
                  },
                  sessionCache: sessionCache
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          error = _this$state.error,
          value = _this$state.value,
          originalFile = _this$state.originalFile;
      return children({
        pick: this.pick,
        value: value,
        originalFile: originalFile,
        error: error
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var nextState = null;

      if (props.value !== state.value) {
        nextState = {
          value: props.value
        };
      }

      return nextState;
    }
  }]);

  return FileInput;
}(react_1.default.Component), _a.defaultProps = {
  maxFiles: 1,
  value: null,
  sessionCache: false
}, _a));
exports.FileInput = FileInput;